import { vnDate } from "@hisense/shared";

/** Trạng thái còn đang xử lý của một hồ sơ hậu mãi — sửa được, gắn phiếu trả được, tính quá hạn. */
export const OPEN_TICKET_STATES: readonly string[] = ["Open", "InProgress", "Waiting"];

/**
 * Hạn trả lời khách đã qua mà hồ sơ chưa xử lý xong (19/09/2026, TKT-R02). Hạn là ngày (YYYY-MM-DD) theo giờ Việt Nam (20/09/2026 — trước đó theo giờ máy người xem); đúng ngày hạn
 * chưa tính là quá. Hồ sơ Đã xử lý / Đóng / Huỷ không bao giờ quá hạn — việc với khách đã xong.
 */
export function isOverdue(r: { status: string; definition: { dueDate?: string } }, today = vnDate()): boolean {
  return !!r.definition.dueDate && OPEN_TICKET_STATES.includes(r.status) && r.definition.dueDate < today;
}
